import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contatti from "./pages/Contatti";
import Iscrizione from "./pages/Iscrizione";
import Pagamento from "./pages/Pagamento";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TerminiCondizioni from "./pages/TerminiCondizioni";
import PoliticaRimborsi from "./pages/PoliticaRimborsi";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/iscrizione" element={<Iscrizione />} />
            <Route path="/pagamento" element={<Pagamento />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/termini" element={<TerminiCondizioni />} />
            <Route path="/rimborsi" element={<PoliticaRimborsi />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
